// import { paginationDataToShow } from "../actions/generalActions";
import {
  CITY_CREATE_REQUEST,
  CITY_CREATE_SUCCESS,
  CITY_CREATE_FAIL,
  ALL_CITY_VIEW_REQUEST,
  ALL_CITY_VIEW_SUCCESS,
  ALL_CITY_VIEW_FAIL,
  CITY_UPDATE_REQUEST,
  CITY_UPDATE_SUCCESS,
  CITY_UPDATE_FAIL,
} from "../constants";

export const cityReducer = (
  state = {
    city: {
      city: null,
      loading: false,
    },
  },
  action
) => {
  switch (action.type) {
    case CITY_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CITY_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CITY_CREATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // CITY VIEW TABLE
    case ALL_CITY_VIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_CITY_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        city: action.payload,
      };
    case ALL_CITY_VIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // CITY UPDATE
    case CITY_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CITY_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        // old code hata dya
        city: state.city.map((x) =>
          x.id == action.payload.id ? action.payload : x
        ),
      };
    case CITY_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
